import React, {forwardRef} from 'react'
import './App.js';
import { Card,CardContent,Typography } from '@material-ui/core'
import './Message.css';

//Changed from function to const to be an ES6 function.
//Message is a higher order function.
//forwardRef passes components to the child.
const Message = forwardRef(({message, username}, ref) => { //Component for messages.
   
    //Checks the user is the one who wrote the messages.
    const isUser = username === message.username;
    return (
        //BEM Naming convention below.
        <div ref = {ref} className={`message ${isUser && 'message__user'}`}>
            {/*If the user is logged in, show blue otherwise show grey.  */}
        <Card className = {isUser ? "message__userCard" : "message__guestCard"}>
            <CardContent>
                <Typography color="white" variant="h5" component="h2">
                {/*If it's not the user, show the name. If it's null, show as unknown */}
                {!isUser && `${message.username || "Unknown User"}:`} {message.message}
            </Typography>
            </CardContent>
        </Card>

        </div>
    )
})

export default Message
